import {
	Box,
	Grid,
	Typography,
	createStyles,
	makeStyles,
	useTheme,
} from '@material-ui/core';
import { Colors, Fonts } from '../../utils/styles/DefaultTheme';
import React, { useContext, useMemo, useState } from 'react';

import { CardContext } from '../../context/cardContext';
import Countdown from 'react-countdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Raffle } from '../../lib/types';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { useRafflesStore } from '../../hooks/useRafflesStore';
import { useWallet } from '@solana/wallet-adapter-react';

import styled from 'styled-components';

const RaffleContainer = styled.div`
	color: white;

	display: flex;
	justify-content: space-evenly;
	align-items: center;

	.description-container {
		text-align: center;
		overflow: auto !important;
		height: 120px;
		background-color: #383555;
		border: 8px solid #2B2941;
		padding: 6px 40px;
		color:#c6ff00;
		font-size: 14px;

		&.ended {
			color: white;
		}

		&.claimed {
			color: white !important;
		}
	}

	@media (max-width: 1200px) {
		flex-direction: column;
	}
`

const StationContainer = styled.div`
	flex: 1 50%;
	margin: 0 10px;
	background-image: url('/cardBg.png');
	background-repeat: no-repeat;
	background-size: contain;

	position: relative;

	width: 600px;
	font-size: 20px;

	padding: 48px;

	h1 {
		text-align: center;
	}

	.card-icon {
		display: block;
		text-align: left;
		position: absolute;
		top: -30px;
		height: 100px;
	}

	.tickets-container {
		display: flex;
		justify-content: space-between;
	}

	.purchase-container {
		display: flex;
		align-items: center;

		img {
			height: 60px;

			:hover {
				cursor: pointer;
			}
		}

		.tickets-container {
			display: flex;
			flex-direction: row !important;
			align-items: center;
			margin-left: 50px;

			div {
				background-image: url('/numTicketsBg.png');
				background-repeat: no-repeat;
				background-size: contain;

				margin-left: 30px;
				height: 60px;

				input {
					margin: 12px 54px;
					height: 30px;
					width: 75px;

					background-color: #6B678D;
					color: white;
				}
			}
		}
	}

	.back-button {
		position: absolute;
		bottom: -80px;
		height: 60px;
		margin-left: auto;
		margin-right: auto;
		left: 0;
		right: 0;
		text-align: center;

		:hover {
			cursor: pointer;
		}
	}

	/* Ended State */
	.claim-button {
		display: block;
		margin: 0 auto;
		height: 60px;

		:hover {
			cursor: pointer;
		}
	}

	/* Claimed State */
	.ended-text {
		font-size: 40px;
		text-align: center;
		color: #75FB83;
		line-height: 0;
	}

	@media (max-width: 1200px) {
		background-image: none;
		background-color: #4B4867;

		border: 8px solid #222034;
		border-radius: 8px;

		width: 800px;

		.purchase-container{
			justify-content: space-between;
			.tickets-container {
				margin-left: 250px;
			}
		}
	}

	@media (max-width: 1000px) {
		width: 600px;

		.purchase-container{
			flex-direction: column-reverse;

			.tickets-container {
				margin: 24px;
				margin-left: 72px;
			}
		}
	}

	@media (max-width: 800px) {
		width: 400px;

		.tickets-container {
			flex-direction: column;
		}
	}
	
	@media (max-width: 550px) {
		width: 200px;
		text-align: center;

		h1 {
			font-size: 30px;
			margin: 36px 0;
		}

		.purchase-container > .tickets-container {
			flex-direction: column !important;
			margin-left: 36px;
		}

		.back-button {
			height: 40px;
		}
	}
`

const PrizeContainer = styled.div`
	flex: 1 50%;
	margin: 0 10px;

	img {
		border: 2px solid black;
		border-radius: 8px;
		width: 100%;
		box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;
	}
	
	h3 {
		text-align: right;
	}

	p {
		text-align: center;
	}

	@media (max-width: 1200px) {
		h3 {
			text-align: center;
		}

		margin-top: 100px;
	}
`

const useStyle = makeStyles((theme) =>
	createStyles({
		bodyCardContainer: {
			background: Colors.SECONDARY,
			padding: theme.spacing(1.25),
			position: 'relative',
		},
		imgContainer: {
			width: '100%',
			'& img': {
				width: '100%',
				height: 'auto',
			},
		},
		cardContainer: {
			backgroundRepeat: `no-repeat`,
			backgroundSize: `contain`,
		},
		title: {
			fontFamily: Fonts.Bebas,
			fontSize: '1.5rem',
			fontWeight: 400,
			color: Colors.black,
			display: 'block',
			marginTop: theme.spacing(1.25),
			position: 'relative',
			paddingBottom: theme.spacing(0.5),
			marginBottom: theme.spacing(1),
			textTransform: 'uppercase',
			'&:after': {
				position: 'absolute',
				content: '""',
				width: '100%',
				height: '1px',
				opacity: 0.1,
				background: Colors.black,
				bottom: 0,
				left: 0,
			},
		},
		info: {
			fontFamily: Fonts.ShareTech,
			fontSize: '1.125rem',
			color: Colors.black,
		},
		timerBox: {
			height: '32px',
			width: '32px',
			border: '1px solid rgba(0, 0, 0, 0.6)',
			marginRight: theme.spacing(0.25),
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
		},
		timerInfo: {
			fontFamily: Fonts.ShareTech,
			fontSize: '1rem',
			color: Colors.black,
		},
		greyCtaBtn: {
			width: '100%',
			marginTop: theme.spacing(2),
			padding: theme.spacing(1, 2),
			display: 'flex',
			justifyContent: 'flex-end',
			alignItems: 'center',
			border: 0,
			outline: 0,
			fontFamily: Fonts.Bebas,
			fontSize: '1.25rem',
			color: Colors.black,
			textTransform: 'uppercase',
			cursor: 'pointer',
			background: Colors.grey,
			'&:hover': {
				background: Colors.black,
				color: Colors.SECONDARY,
			},
			'& svg': {
				marginLeft: theme.spacing(1),
			},
		},
		badge: {
			position: 'absolute',
			top: 0,
			left: theme.spacing(2.5),
			background:
				'linear-gradient(93.09deg, #FF00C7 -30.79%, #00FFD1 42.53%, #FFF500 118.97%)',
			padding: theme.spacing(0.75, 1.5),
		},
		badgeInfo: {
			fontFamily: Fonts.Bebas,
			fontSize: '1.25rem',
			color: Colors.black,
			textTransform: 'uppercase',
		},
		ctaBtn: {
			width: '100%',
			marginTop: theme.spacing(2),
			padding: theme.spacing(1, 2),
			display: 'flex',
			justifyContent: 'flex-end',
			alignItems: 'center',
			border: `3px solid ${Colors.black}`,
			fontFamily: Fonts.Bebas,
			fontSize: '1.25rem',
			color: Colors.black,
			textTransform: 'uppercase',
			cursor: 'pointer',
			background: Colors.SECONDARY,
			'&:hover': {
				background: Colors.black,
				color: Colors.SECONDARY,
			},
			'& svg': {
				marginLeft: theme.spacing(1),
			},
		},
	})
);

export interface HomeBodyCardType {
	image: string;
	title: string;
	entries: number;
	winner: number;
	time?: number | string;
	numUniqueWallets: number;
	ticketPrice: number;
	raffleId: string;
	raffle: Raffle;
	description: string;
	total: number;
}

interface HomeBodyCardProps extends HomeBodyCardType {}

interface renderTimeType {
	hours: number;
	days: number;
	minutes: number;
	seconds: number;
	completed: boolean;
}

export default function HomeBodyCard({
	image,
	title,
	entries,
	winner,
	time,
	numUniqueWallets,
	ticketPrice,
	raffleId,
	raffle: raffleOld,
	description,
	total,
}: HomeBodyCardProps) {
	const classes = useStyle();
	const theme = useTheme();
	const [card, setCard] = useContext(CardContext);
	const [timerEnded, setTimerEnded] = useState(false);

	const { publicKey } = useWallet();
	const navigate = useNavigate();

	const { raffles } = useRafflesStore();
	const raffle = useMemo(() => raffles.get(raffleId), [raffleId, raffles]);

	const onClickJoinRaffle = () => {
		const card: HomeBodyCardType = {
			title,
			image,
			entries,
			winner,
			time,
			numUniqueWallets,
			ticketPrice,
			raffleId,
			raffle,
			description,
			total,
		};
		setCard?.(card);

		if (timerEnded) {
			navigate('/raffle-table');
		} else {
			navigate('/raffle-buy');
		}
	};

	const userHasJoined = React.useMemo(() => {
		return !!(raffle?.entrants?.get(publicKey?.toBase58()) || false);
	}, [publicKey, raffle]);

	const renderer = ({
		days,
		hours,
		minutes,
		seconds,
		completed,
	}: renderTimeType) => {
		if (completed) {
			setTimerEnded(true);
			return (
				<Box display={'flex'}>
					<Box
						style={{
							border: '1px solid #FFCCCC',
							padding: theme.spacing(0.5, 1),
							height: '30px',
						}}
						display="flex"
						justifyContent="center"
						alignItems="center"
					>
						<Typography
							style={{
								fontFamily: Fonts.ShareTech,
								color: '#FF0000',
								fontSize: '0.9rem',
							}}
						>
							ENDED
						</Typography>
					</Box>
				</Box>
			);
		} else {
			return (
				<Box display={'flex'}>
					<Box className={classes.timerBox}>
						<Typography
							style={{
								color: days === 0 && hours === 0 ? '#FF0000' : Colors.black,
							}}
							className={classes.timerInfo}
						>
							{days}d
						</Typography>
					</Box>
					<Box className={classes.timerBox}>
						<Typography
							style={{
								color: days === 0 && hours === 0 ? '#FF0000' : Colors.black,
							}}
							className={classes.timerInfo}
						>
							{hours}h
						</Typography>
					</Box>
					<Box className={classes.timerBox}>
						<Typography
							style={{
								color: days === 0 && hours === 0 ? '#FF0000' : Colors.black,
							}}
							className={classes.timerInfo}
						>
							{minutes}m
						</Typography>
					</Box>
					<Box className={classes.timerBox}>
						<Typography
							style={{
								color: days === 0 && hours === 0 ? '#FF0000' : Colors.black,
							}}
							className={classes.timerInfo}
						>
							{seconds}s
						</Typography>
					</Box>
				</Box>
			);
		}
	};

	const state = "main";
	// const state = "ended";
	// const state = "claimed";

	if (state === "main" ) {
		return (
			<RaffleContainer>
				<StationContainer>
					<img src="/cardIcon.png" alt="Card Icon" className='card-icon'/>
					<h1>Raffle Station</h1>
					<div className='description-container'>
						<p>"This is a very long description. This is a very long description. This is a very long description. This is a very long description. This is a very long description. This is a very long description. This is a very long description. "</p>
					</div>
					<div>
						<p>Price: 100 Junkz</p>
						<div className='tickets-container'>
							<p>Tickets Sold: 10</p>
							<p>Owned: 10</p>
						</div>
						<div className='purchase-container'>
							<img src="/buyButton.png" alt="Buy Tickets" />
							<div className='tickets-container'>
								<p>Amount</p>
								<div>
									<input type="text" />
								</div>
							</div>
						</div>
					</div>
					<img src="/backButton.png" alt="Back Button" className='back-button'/>
				</StationContainer>
				<PrizeContainer>
					<h3>Raffle Prize</h3>
					<div>
						<img src="/nft_test.png" alt="NFT Raffled" />
					</div>
					<p>1x Zankoku Arcanisis</p>
				</PrizeContainer>
			</RaffleContainer>
		);
	} else if (state === "ended") {
		return (
			<RaffleContainer>
				<StationContainer>
					<img src="/cardIcon.png" alt="Card Icon" className='card-icon'/>
					<h1>Raffle Station</h1>
					<div className='description-container'>
						<p>Winners</p>
						<p>WALLET 11111111111111111111111111111111 WALLET 11111111111111111111111111111111</p>
					</div>
					<div>
						<p>Burned: 1,000,000 Junkz</p>
						<p>Tickets Sold: 10</p>
						<img src="/claimButton.png" alt="Claim Button" className='claim-button'/>
					</div>
					<img src="/backButton.png" alt="Back Button" className='back-button'/>
				</StationContainer>
				<PrizeContainer>
					<h3>Raffle Prize</h3>
					<div>
						<img src="/nft_test.png" alt="NFT Raffled" />
					</div>
					<div className='description-container ended'>
						<p>"This is a very long description. This is a very long description. This is a very long description. This is a very long description. This is a very long description. This is a very long description. This is a very long description. "</p>
					</div>
				</PrizeContainer>
			</RaffleContainer>
		)
	} else if (state === "claimed") {
		return (
			<RaffleContainer>
				<StationContainer>
					<img src="/cardIcon.png" alt="Card Icon" className='card-icon'/>
					<h1>Raffle Station</h1>
					<div className='description-container claimed'>
						<p>Winners</p>
						<p>WALLET 11111111111111111111111111111111 WALLET 11111111111111111111111111111111</p>
					</div>
					<div>
					<div>
						<p>Burned: 1,000,000 Junkz</p>
						<p>Tickets Sold: 10</p>
						<p className='ended-text'>Raffle Ended</p>
					</div>
					</div>
					<img src="/backButton.png" alt="Back Button" className='back-button'/>
				</StationContainer>
				<PrizeContainer>
					<h3>Raffle Prize</h3>
					<div>
						<img src="/nft_test.png" alt="NFT Raffled" />
					</div>
					<div className='description-container ended'>
						<p>"This is a very long description. This is a very long description. This is a very long description. This is a very long description. This is a very long description. This is a very long description. This is a very long description. "</p>
					</div>
				</PrizeContainer>
			</RaffleContainer>
		)
	}
}
